/* My Pure Herb — site updates (29 Sep 2026). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Product gallery: arrows, swipe, keyboard, counter ---------- */
  function initGallery(stage) {
    if (stage._mph) return;
    stage._mph = true;
    var root = stage.closest('[data-gallery]');
    if (!root) return;
    var thumbs = $$('[data-thumb]', root);
    if (thumbs.length < 2) return;
    var strip = $('.product__thumbs', root);
    var counter = $('[data-gallery-count]', stage);

    function current() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }
    function preload(i) {
      var t = thumbs[(i + thumbs.length) % thumbs.length];
      if (t && !t._pre) { t._pre = true; var im = new Image(); im.src = t.getAttribute('data-src'); }
    }
    function sync(i) {
      if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
      var t = thumbs[i];
      if (strip && t) {
        var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      preload(i + 1); preload(i - 1);
    }
    function go(i) {
      i = (i + thumbs.length) % thumbs.length;
      thumbs[i].click(); // the theme's own handler swaps the main image
    }
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (th) window.setTimeout(function () { sync(thumbs.indexOf(th)); }, 0);
    });
    var prev = $('[data-gallery-prev]', stage), next = $('[data-gallery-next]', stage);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    });
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(current() + (dx < 0 ? 1 : -1));
    }, { passive: true });
    sync(current());
  }
  $$('[data-gallery-stage]').forEach(initGallery);

  /* ---------- Reels: silent previews + pop-up player ---------- */
  function initReels(section) {
    if (section._mph) return;
    section._mph = true;
    var dialog = $('[data-reel-modal]', section), body = $('[data-reel-body]', section);
    var previews = $$('video.reel__preview', section);
    var saveData = navigator.connection && navigator.connection.saveData;

    if (previews.length && 'IntersectionObserver' in window && !reduceMotion && !saveData) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && !(dialog && dialog.open)) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.6 });
      previews.forEach(function (v) { io.observe(v); });
    }

    function close() {
      if (!dialog) return;
      if (dialog.open && dialog.close) dialog.close(); else dialog.removeAttribute('open');
      body.innerHTML = '';
    }
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-reel-open]');
      if (!btn || !dialog) return;
      var tpl = $('template[data-reel-template]', btn.closest('.reel-card'));
      if (!tpl) return;
      previews.forEach(function (v) { v.pause(); });
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      var v = $('video', body);
      if (v) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      var c = $('[data-reel-close]', dialog); if (c) c.focus();
    });
    if (dialog) {
      $('[data-reel-close]', dialog).addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('close', function () { body.innerHTML = ''; });
    }
  }
  $$('[data-reels]').forEach(initReels);

  /* ---------- Activity / discovery pop-ups ---------- */
  function initActivity() {
    var el = $('[data-activity-toast]'), json = $('[data-activity-json]');
    if (!el || !json || el._mph) return;
    el._mph = true;
    var cfg;
    try { cfg = JSON.parse(json.textContent); } catch (e) { return; }
    var path = window.location.pathname.replace(/\/$/, '');
    var items = (cfg.items || []).filter(function (it) { return it && it.url && it.url.replace(/\/$/, '') !== path; });
    if (!items.length) return;
    if (!cfg.mobile && window.matchMedia('(max-width: 749px)').matches) return;
    if (store.get('mph_activity_off') === '1') return;
    if (window.Shopify && window.Shopify.designMode) return;

    var shown = parseInt(store.get('mph_activity_count') || '0', 10);
    var idx = parseInt(store.get('mph_activity_idx') || String(Math.floor(Math.random() * items.length)), 10) % items.length;
    var hideTimer = null, nextTimer = null, paused = false;

    function busy() {
      return document.hidden || !!$('.cart-drawer.is-open, .mnav.is-open, .search-modal.is-open, dialog[open]');
    }
    // Never sit on top of an Add to cart / Buy button
    function coversButtons() {
      var mobile = window.innerWidth < 750;
      var sticky = $('.sticky-buy.is-on');
      var bottom = sticky ? sticky.offsetHeight + 12 : 16;
      var h = el.offsetHeight || 76;
      var zone = { top: window.innerHeight - bottom - h - 8, bottom: window.innerHeight - bottom + 4, left: mobile ? 0 : 0, right: mobile ? window.innerWidth : Math.min(372, window.innerWidth) };
      return $$('[data-add-btn], [data-dynamic-checkout], .product__buy button, .card__cta .btn, .card__cta button, .cart-drawer button[type=submit]').some(function (b) {
        var r = b.getBoundingClientRect();
        if (!r.width || !r.height) return false;
        return r.bottom > zone.top && r.top < zone.bottom && r.right > zone.left && r.left < zone.right;
      });
    }
    function place() {
      var sticky = $('.sticky-buy.is-on');
      el.style.setProperty('--activity-bottom', sticky ? (sticky.offsetHeight + 12) + 'px' : '1rem');
    }
    function hide() {
      el.classList.remove('is-on');
      window.setTimeout(function () { if (!el.classList.contains('is-on')) el.hidden = true; }, 320);
    }
    function schedule(ms) {
      window.clearTimeout(nextTimer);
      if (shown >= cfg.maxPerVisit || store.get('mph_activity_off') === '1') return;
      nextTimer = window.setTimeout(show, ms);
    }
    function show() {
      if (busy() || coversButtons()) { schedule(6000); return; }
      var it = items[idx % items.length];
      idx = (idx + 1) % items.length;
      store.set('mph_activity_idx', String(idx));
      $('[data-activity-link]', el).setAttribute('href', it.url);
      $('[data-activity-kicker]', el).textContent = it.kicker || '';
      $('[data-activity-title]', el).textContent = it.title || '';
      $('[data-activity-text]', el).textContent = it.text || '';
      var imgWrap = $('[data-activity-img]', el);
      imgWrap.innerHTML = '';
      if (it.img) { var im = new Image(); im.src = it.img; im.alt = ''; im.width = 52; im.height = 52; imgWrap.appendChild(im); }
      place();
      el.hidden = false;
      window.requestAnimationFrame(function () { el.classList.add('is-on'); });
      shown += 1;
      store.set('mph_activity_count', String(shown));
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () { if (!paused) { hide(); schedule(cfg.interval); } }, cfg.visible);
    }
    el.addEventListener('mouseenter', function () { paused = true; window.clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', function () {
      paused = false;
      hideTimer = window.setTimeout(function () { hide(); schedule(cfg.interval); }, 2500);
    });
    $('[data-activity-close]', el).addEventListener('click', function () {
      store.set('mph_activity_off', '1');
      window.clearTimeout(nextTimer); window.clearTimeout(hideTimer);
      hide();
    });
    window.addEventListener('scroll', function () {
      if (el.hidden) return;
      place();
      if (el.classList.contains('is-on') && coversButtons()) { window.clearTimeout(hideTimer); hide(); schedule(cfg.interval); }
    }, { passive: true });
    schedule(cfg.firstDelay);
  }
  initActivity();

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-gallery-stage]', e.target).forEach(initGallery);
    $$('[data-reels]', e.target).forEach(initReels);
  });
})();